import PlayerHTML from "./player.html";

export default function ($app) {
    return new PlayerHTML($app);
}
